// extracted by mini-css-extract-plugin
module.exports = {"input":"index-input-3p_kO"};